import LegalPage, { Section } from "@/components/LegalPage";

const UPDATED = "June 1, 2026";

export default function Terms() {
  return (
    <LegalPage eyebrow="TERMS OF SERVICE" title="Plain-English terms." updated={UPDATED} testid="terms-page">
      <p>
        These Terms govern your use of the Clawback website and application (the "Service") operated by Clawback ("we", "us").
        By creating an account you agree to these Terms and to our <a href="/privacy" className="text-[#00E676]">Privacy Policy</a>.
      </p>

      <Section title="1. What Clawback does">
        <p>
          Clawback scans receipts you authorize us to read, shows recurring charges and trials, and helps you cancel subscriptions,
          draft refund requests and file class-action claims. We <b className="text-[#F4F1EA]">never</b> hold your money, access your bank or cards, or
          cancel on your behalf without your action. Cancellations, refunds and payouts are ultimately decided by the merchant, platform,
          bank or settlement administrator — we cannot guarantee any outcome or amount.
        </p>
      </Section>

      <Section title="2. Eligibility and accounts">
        <p>You must be at least 18 and able to form a binding contract. Keep your credentials confidential; you are responsible for activity under your account. Provide accurate information and only connect email accounts you own or are authorized to use.</p>
      </Section>

      <Section title="3. Membership, billing and cancellation">
        <ul className="list-disc pl-5 space-y-2">
          <li>Paid features require a membership: <b className="text-[#F4F1EA]">$12.99 per month</b> or <b className="text-[#F4F1EA]">$99 per year</b>, billed in advance through Stripe and renewing automatically until cancelled.</li>
          <li>You can switch plans or cancel anytime from <i>Manage plan</i> in your dashboard. Cancellation takes effect at the end of the current billing period; you keep access until then. Fees already paid are non-refundable except where required by law.</li>
          <li>Prices may change with at least 30 days' notice; changes apply from your next renewal.</li>
          <li>Taxes may be added where applicable.</li>
        </ul>
      </Section>

      <Section title="4. Acceptable use">
        <p>You agree not to: use the Service for unlawful purposes or to submit false refund or settlement claims; connect accounts you do not own; attempt to access other users' data; reverse-engineer, scrape or overload the Service; or resell it without permission.</p>
      </Section>

      <Section title="5. Third-party services">
        <p>The Service relies on Google (Gmail API), Stripe and AI providers, and links to merchants, app stores and settlement websites we do not control. Their terms and privacy policies apply to your use of them. Our use of Google user data is described in our Privacy Policy and complies with the Google API Services User Data Policy.</p>
      </Section>

      <Section title="6. AI-generated content">
        <p>Refund letters, cancellation scripts and spending insights are generated by AI and may contain errors. Review them before sending or relying on them. Nothing in the Service is legal, financial or tax advice.</p>
      </Section>

      <Section title="7. Intellectual property">
        <p>The Service, its design and content are owned by Clawback and its licensors. You keep ownership of your data and grant us a limited license to process it to provide the Service.</p>
      </Section>

      <Section title="8. Disclaimers">
        <p>THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT CHARGES WILL BE DETECTED, CANCELLED OR REFUNDED, OR THAT THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE.</p>
      </Section>

      <Section title="9. Limitation of liability">
        <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, CLAWBACK WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR LOST PROFITS OR DATA. OUR TOTAL LIABILITY FOR ANY CLAIM IS LIMITED TO THE AMOUNT YOU PAID US IN THE 12 MONTHS BEFORE THE CLAIM.</p>
      </Section>

      <Section title="10. Termination">
        <p>You may stop using the Service and delete your account at any time. We may suspend or terminate accounts that violate these Terms or create risk for us or others. Sections that by their nature should survive termination will survive.</p>
      </Section>

      <Section title="11. Changes to these Terms">
        <p>We may update these Terms; material changes will be announced by email or in the app at least 14 days before they take effect. Continued use after that date means you accept the new Terms.</p>
      </Section>

      <Section title="12. Governing law and disputes">
        <p>These Terms are governed by the laws of the State of Delaware, USA, without regard to conflict-of-law rules. Disputes will be resolved in the state or federal courts located in Delaware, unless applicable consumer law gives you the right to bring a claim in your home jurisdiction.</p>
      </Section>

      <Section title="13. Contact">
        <p>Questions about these Terms: <a href="mailto:support@refundbot.org" className="text-[#00E676]">support@refundbot.org</a></p>
      </Section>
    </LegalPage>
  );
}
